export default __webpack_public_path__ + "static/media/punctualvector.548dcdb5.svg";